/**
 * Display formatting shared by the video grid and the video viewer panel, so a tile and
 * the panel it opens never disagree about a video's date or runtime.
 */

/** e.g. "Aug 12, 2026". Falls back to the raw string if the date can't be parsed. */
export const formatVideoDate = (isoDate: string): string => {
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return isoDate;
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

/**
 * e.g. "1:24". Null when there is no runtime to show — the API leaves it unset on uploads
 * whose duration was never probed, and a "0:00" badge would read as a broken video.
 */
export const formatVideoDuration = (seconds: number | null | undefined): string | null => {
  if (!seconds) return null;
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};
